import React, {useEffect, useRef} from 'react';
import {Button, Divider, Paper} from "@mui/material";
import cl from "./FormMuseumEventVisitsEditorItem.module.css";
import FormInput from "../../formComponents/FormInput";
import FormUrlInput from "../../formComponents/FormUrlInput";
import FormLinkedItemSimpleSelect from "../../formComponents/FormLinkedItemSimpleSelect";
import {allAges} from "../../data/Enums";
import FormLinkedItemSelect from "../../formComponents/FormLinkedItemSelect";

const FormMuseumEventVisitsEditorItem = ({id, initData, controlRef, index, onDelete, initDataRefs, readOnly}) => {

    const controlRefType = useRef(null);
    const controlRefDescription = useRef(null);
    const controlRefAge = useRef(null);
    const controlRefDuration = useRef(null);
    const controlRefUrl = useRef(null);

    useEffect(() => {
        if (controlRef) {
            const list = controlRef.current;
            let item = list.find(x => x.id === id);
            if (!item) {
                item = {id: id};
                list.push(item);
            }
            item.current = {
                validate: validate,
                getData: getData,
            };
        }
    })

    function validate() {
        let isValid = true;

        if (!controlRefType.current.validateIsSelected("Нужно выбрать тип!"))
            isValid = false;

        if (!controlRefDescription.current.validateLength(1000))
            isValid = false;

        if (!controlRefAge.current.validateIsSelected("Нужно выбрать возрастное ограничение!"))
            isValid = false;

        /*if (!controlRefAge.current.validate("Нужно указать возрастное ограничение (или убрать галку выше)!", "Неверно указано возрастное ограничение!"))
            isValid = false;*/

        if (!controlRefDuration.current.validateText("Неверно указана продолжительность!"))
            isValid = false;

        if (!controlRefUrl.current.validateNotEmpty("Нужно указать сайт!"))
            isValid = false;
        else if (!controlRefUrl.current.validateUrl("Неверно указан адрес сайта!"))
            isValid = false;
        else if (!controlRefUrl.current.validateLength(2000))
            isValid = false;

        return isValid;
    }

    function getData() {
        return {
            id: controlRefType.current.getSelectedId(), // NZ required
            description: controlRefDescription.current.getText(),
            age: getAgeData(controlRefAge),
            /*age: controlRefAge.current.getValue(),*/
            duration: getDurationData(),
            url: controlRefUrl.current.getUrl(), // required valid url
        };
    }

    function getDurationData() {
        const str = controlRefDuration.current.getText();
        if (str === "")
            return null;

        const regex = /^(\d+)\s*:\s*(\d+)$/;
        const match = regex.exec(str);
        const h = parseInt(match[1]);
        const m = parseInt(match[2]);
        return (h * 60 + m) * 60; // [sec]
    }

    return (
        <Paper variant="outlined" sx={{
            backgroundColor: "#40400010",
            maxWidth: "560px",
            padding: "10px",
            display: "flex",
            flexDirection: "column",
            gap: "15px"
        }}>
            <div className={cl.header}>
                <p className={cl.title}>Вариант посещения #{index + 1}</p>
                {/*<p className={cl.title}>Вариант посещения</p>*/}
                {!readOnly && <FooterButton
                    label="Удалить"
                    sx={{borderColor: "gray", color: "#844", width: "100px"}}
                    onClick={() => onDelete(id)}
                />}
            </div>
            <Divider/>
            <FormLinkedItemSelect
                controlRef={controlRefType}
                label="Тип"
                widthLimit={430}
                initSelectedId={initData?.visit_type_id}
                initRefList={initDataRefs?.visit_types}
                apiName2="visit_types"
                showIds={true}
                readOnly={readOnly}
            />
            <FormInput
                controlRef={controlRefDescription}
                label={"Описание"}
                widthLimit={500}
                initValue={initData?.description ?? ""}
                tipText={"Например, \"сборная группа до 10 чел, по предварительной записи\""}
                readOnly={readOnly}
            />
            <FormLinkedItemSimpleSelect
                controlRef={controlRefAge}
                label="Возрастное ограничение"
                widthLimit={150}
                initSelectedId={initData ? (initData.age ?? -1) : undefined}
                options={ageOptions}
                readOnly={readOnly}
            />
            {/*<FormAgeWithCheckbox
                controlRef={controlRefAge}
                label={"Имеется возрастное ограничение"}
                initValue={initData?.age}
                tipText={"Если у варианта посещения есть возрастное ограничение, то поставьте галку и введите ниже возрастное ограничение от 0+ до 18+.\nЗнак плюс ставить не обязательно. Например, 12+ и 12 это одно и то же."}
            />*/}
            <FormInput
                controlRef={controlRefDuration}
                label="Продолжительность"
                widthLimit={100}
                initValue={getInitialDuration(initData?.duration)}
                placeholder="Ч:ММ"
                validateTextFunc={text => !text || validateDuration(text, false)}
                readOnly={readOnly}
            />
            <FormUrlInput
                controlRef={controlRefUrl}
                label="Сайт"
                widthLimit={500}
                initValue={initData?.url ?? ""}
                placeholder="https://..."
                readOnly={readOnly}
            />
        </Paper>
    );
};

const FooterButton = ({label, onClick, sx}) => {
    return <Button variant="outlined" size="small" onClick={onClick} sx={sx}>{label}</Button>
}

// 01:20 --> 1:20
function getInitialDuration(serverDuration) {
    if (!serverDuration)
        return "";

    const regex = /^(\d+):(\d+)$/
    const match = regex.exec(serverDuration.trim());
    return `${parseInt(match[1])}:${match[2].padStart(2, "0")}`;
}

function validateDuration(str, zeroAllowed = true) {
    const regex = /^(\d+)\s*:\s*(\d+)$/;
    const match = regex.exec(str);
    if (!match)
        return false;
    const h = parseInt(match[1]);
    const m = parseInt(match[2]);
    if ((!zeroAllowed && (h + m) === 0) || m >= 60)
        return false;
    return true;
}

const ageOptions = [
    {id: -1, name: "(не указано)"},
    ...allAges
];

function getAgeData(ageControlRef) {
    const selectedId = ageControlRef.current.getSelectedId();
    return selectedId === -1 ? null : selectedId;
}

export default FormMuseumEventVisitsEditorItem;